import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { StoreProvider, Dialog } from '../../components';
import { createQrCode } from '../../mutations';

import QrCodeCell from './QrCodeCell';

export class QrCodes extends Component {
  state = {
    showsGenerateNewQrCodeDialog: false,
  };

  handleGenerateQrCode = () => {
    const { relay } = this.props;
    this.setState({ showsGenerateNewQrCodeDialog: false });

    createQrCode(relay.environment, {
      onError: (error) => console.log(error),
    });
  };

  render() {
    let qrCodes = this.props.lists.qrCodes.edges.map((e) => e.node);

    return (
      <div className="qrCodes">
        <Dialog
          className="creation"
          isOpen={this.state.showsGenerateNewQrCodeDialog}
          message="This will generate new QrCode, and delete the oldest one. Are you sure you want to proceed?"
          onConfirm={this.handleGenerateQrCode}
          onCancel={() =>
            this.setState({ showsGenerateNewQrCodeDialog: false })
          }
        />
        <div className="header">
          <h2>
            QR codes <span className="amount">({qrCodes.length})</span>
          </h2>
          <a
            className="button create"
            onClick={() =>
              this.setState({ showsGenerateNewQrCodeDialog: true })
            }
          >
            Generate new QR code
          </a>
        </div>
        <table className="tables">
          <thead>
            <tr>
              <th>Created at</th>
              <th>Sign</th>
            </tr>
          </thead>
          <tbody>
            {qrCodes.map((qrCode) => (
              <QrCodeCell
                key={qrCode.id}
                qrCode={qrCode}
                lists={this.props.lists}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const QrCodesContainer = createFragmentContainer(QrCodes, {
  lists: graphql`
    fragment QrCodeList_lists on Lists {
      id
      qrCodes(first: 100) @connection(key: "QrCodeList_qrCodes") {
        edges {
          node {
            id
            ...QrCodeCell_qrCode
          }
        }
      }
    }
  `,
});

export default class QrCodeList extends Component {
  render() {
    return (
      <StoreProvider
        container={QrCodesContainer}
        modern
        query={graphql`
          query QrCodeListQuery {
            lists {
              ...QrCodeList_lists
            }
          }
        `}
      />
    );
  }
}
